import { render, staticRenderFns } from "./OrderFooter.vue?vue&type=template&id=d6534ece&scoped=true&"
import script from "./OrderFooter.vue?vue&type=script&lang=js&"
export * from "./OrderFooter.vue?vue&type=script&lang=js&"
import style0 from "./OrderFooter.vue?vue&type=style&index=0&id=d6534ece&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6534ece",
  null
  
)

export default component.exports